import _regeneratorRuntime from 'babel-runtime/regenerator';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import Spinner from '../../common/Spinner/Spinner';
import APIFrame from '../../common/APIFrame/APIFrame';
import get from 'lodash/get';
import './KYCJumioIframeComponent.css';
var classes = getBEMClasses('kyc-jumio');
var KYC_JumioIframeComponent = function (_React$Component) {
  _inherits(KYC_JumioIframeComponent, _React$Component);
  function KYC_JumioIframeComponent() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, KYC_JumioIframeComponent);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = KYC_JumioIframeComponent.__proto__ || Object.getPrototypeOf(KYC_JumioIframeComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      processing: true,
      authToken: null
    }, _this.receiveMessage = function (event) {
      try {
        var data = JSON.parse(event.data);
        if (get(data, 'payload.value') === 'success') {
          _this.props.closeKYC_JumioSidePane();
          _this.props.showSnack({
            id: 'jumioSubmissionSuccess',
            text: _this.context.t('Documents successfully submitted for verification'),
            type: 'success'
          });
          window.removeEventListener('message', _this.receiveMessage);
        }
      } catch (e) {
        // Do nothing.
      }
    }, _this.initializeJumioIframe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, alphaPointSessiontoken, alphaPointUserID, type, payload, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, alphaPointSessiontoken = _this$props.alphaPointSessiontoken, alphaPointUserID = _this$props.alphaPointUserID, type = _this$props.kycConfig.type;
              payload = {
                clientInfo: {
                  alphaPointSessiontoken: alphaPointSessiontoken,
                  alphaPointUserID: alphaPointUserID,
                  validationStage: 1,
                  validator: type
                },
                userInfo: {
                  accountName: alphaPointUserID
                }
              };
              _context.next = 4;
              return _this.props.validateUserRegistrationJumio(payload);
            case 4:
              data = _context.sent;
              if (!data) {
                _context.next = 7;
                break;
              }
              return _context.abrupt('return', _this.setState(Object.assign({
                processing: false
              }, data)));
            case 7:
              return _context.abrupt('return', _this.setState({
                processing: false,
                error: _this.context.t('Our account verification service is having difficulties connecting. Please try again later.')
              }));
            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(KYC_JumioIframeComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('message', this.receiveMessage, false);
      this.initializeJumioIframe();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
        processing = _state.processing,
        error = _state.error;
      if (processing) {
        return React.createElement(Spinner, {
          isVisible: processing
        });
      }
      if (error) {
        return React.createElement('p', {
          className: classes('error')
        }, error);
      }
      return React.createElement(APIFrame, {
        id: 'jumio-iframe',
        src: this.state.RedirectUrl,
        customClass: 'jumio'
      });
    }
  }]);
  return KYC_JumioIframeComponent;
}(React.Component);
KYC_JumioIframeComponent.contextTypes = {
  t: PropTypes.func.isRequired
};
export default KYC_JumioIframeComponent;